import styled from 'styled-components';

type Props = {};

type FormSectionProps = {};

export default styled.section<Props>``;

export const FormSection = styled.section<FormSectionProps>``;
